import React from 'react';
import './HomePage.css';
import Carousel from 'react-bootstrap/Carousel';

const TopAutoSlide = () => {
  return (
 <>
  <div className="container-fluid" id='homepage-top-slide'>
  <Carousel controls={false} indicators={false} className="slider" pause={"hover"|false}>
      <Carousel.Item className="slider-item item-1" interval={5000} >
        <div className="row">
            <div className="col
            left-col">
                <h1>Advanced Power Solutions for Metro and Railways</h1>
                <p>"Conwave Power Solutions delivers cutting-edge power systems for Metro and railways, ensuring efficient, reliable, and sustainable energy management, enhancing transportation infrastructure for urban and intercity networks."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-2" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Precision Engineering in Electrical Switchboards and Control Panels</h1>
                <p>"Conwave Power Solutions specializes in designing and manufacturing high-performance electrical switchboards, control, and relay panels, ensuring seamless and secure power distribution for critical industrial applications."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item >
      <Carousel.Item className="slider-item item-3" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Expert PLC Programming for Optimized Industrial Automation</h1>
                <p>"Conwave Power Solutions offers advanced PLC programming services, enabling efficient and reliable automation for complex industrial processes, enhancing operational productivity and system integration."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-4" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Comprehensive SCADA Solutions for Intelligent System Monitoring</h1>
                <p>"Conwave Power Solutions provides robust SCADA solutions, offering real-time monitoring and control for industrial systems, ensuring enhanced efficiency, safety, and decision-making capabilities across various operations."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-5" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Specialists in Synchronization of Diesel, Gas Generators, and Utility Systems</h1>
                <p>" Conwave Power Solutions excels in synchronizing diesel and gas generators with utility systems, ensuring seamless power transitions, optimal performance, and uninterrupted energy supply for diverse industrial applications."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
      <Carousel.Item className="slider-item item-6" interval={5000}>
      <div className="row">
            <div className="col
            left-col">
                <h1>Expertise in On-Grid, Off-Grid, and Hybrid Solar Solutions</h1>
                <p>"Conwave Power Solutions provides tailored solar solutions, including on-grid, off-grid, and hybrid systems, delivering sustainable energy alternatives that maximize efficiency and reliability for various energy needs."</p>
            </div>
            <div className="col right-col">
             &nbsp;
            </div>
        </div>
      </Carousel.Item>
    </Carousel>
  </div>
 </>
  )
}

export default TopAutoSlide
